import { render, staticRenderFns } from "./modalModificarTipoCompra.vue?vue&type=template&id=019383c8&"
import script from "./modalModificarTipoCompra.vue?vue&type=script&lang=js&"
export * from "./modalModificarTipoCompra.vue?vue&type=script&lang=js&"
import style0 from "./modalModificarTipoCompra.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('019383c8')) {
      api.createRecord('019383c8', component.options)
    } else {
      api.reload('019383c8', component.options)
    }
    module.hot.accept("./modalModificarTipoCompra.vue?vue&type=template&id=019383c8&", function () {
      api.rerender('019383c8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/chile/dte/componentes/acciones/modales/modalModificarTipoCompra.vue"
export default component.exports